// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileImport__container___cuAl4 {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    justify-content: space-between;

    width: 32rem;

    border-right: 0.1rem solid var(--color-bg-border);
}

.FileImport__wrapper___NPQ6r {
    display: flex;
    justify-content: space-between;
    margin: 0.8rem 1.2rem;
}

.FileImport__filesCard___QDAyd,
.FileImport__activeFileCard___SJXIS {
    display: flex;
    flex-direction: column;
}

.FileImport__filesCard___QDAyd {
    background-color: var(--color-bg-ghost);
}

.FileImport__activeFileCard___SJXIS {
    background-color: var(--color-bg-border);
}

.FileImport__btnChooseAll___KvvVQ {
    padding: 0;
    background-color: var(--color-control-bg-default);
}

.FileImport__tagWrapper___DJICB {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 2.4rem;
}

.FileImport__body___mcyZz {
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.FileImport__filesUploadBtn___Mgc_x {
    justify-content: center;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.FileImport__filesUploadBtn___Mgc_x .Button-Label {
    flex-grow: unset;
    flex-shrink: unset;
}

.FileImport__controlsForFilesCard___ZfXxA {
    margin: 0.8rem 1.2rem;
    border-bottom: solid 0.1rem var(--color-bg-stripe);
}

.FileImport__originSelect___santg {
    margin-right: 0.4rem;
}

.FileImport__statusIcon___o1ffb {
    display: flex;
    margin-right: 0.8rem;
}

.FileImport__filesCardWrapper___kLgm1 {
    margin-top: 0.8rem;
    margin-right: 1.2rem;
    margin-left: 1.2rem;
}

.FileImport__placeholderWrapper___Kk6aN {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;
    justify-content: center;

    margin-right: 1.2rem;
    margin-left: 1.2rem;
}

.FileImport__placeholderText___TpSs6 {
    margin-bottom: 0;
}

.FileImport__buttonsWrapper___UvMjX {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0.8rem 1.2rem;
}

.FileImport__toProject___cn1i6 {
    margin-left: 0.8rem;
}

.FileImport__timer___cUZDl {
    display: flex;
    margin-right: 0.8rem;
}

.FileImport__blockWrapper___onlM4 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.8rem;
}

.FileImport__stepIndicatorWrapper___He9pL {
    display: flex;
    align-items: center;
    margin-bottom: 0.8rem;
}

.FileImport__stepIndicatorCheck___wc8MK {
    margin-right: 1.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/FileImport/FileImport.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,8BAA8B;;IAE9B,YAAY;;IAEZ,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,UAAU;IACV,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,uEAAuE;AACvE;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;;IAEvB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    flex-shrink: 0;\n    justify-content: space-between;\n\n    width: 32rem;\n\n    border-right: 0.1rem solid var(--color-bg-border);\n}\n\n.wrapper {\n    display: flex;\n    justify-content: space-between;\n    margin: 0.8rem 1.2rem;\n}\n\n.filesCard,\n.activeFileCard {\n    display: flex;\n    flex-direction: column;\n}\n\n.filesCard {\n    background-color: var(--color-bg-ghost);\n}\n\n.activeFileCard {\n    background-color: var(--color-bg-border);\n}\n\n.btnChooseAll {\n    padding: 0;\n    background-color: var(--color-control-bg-default);\n}\n\n.tagWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    height: 2.4rem;\n}\n\n.body {\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n}\n\n.filesUploadBtn {\n    justify-content: center;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.filesUploadBtn :global(.Button-Label) {\n    flex-grow: unset;\n    flex-shrink: unset;\n}\n\n.controlsForFilesCard {\n    margin: 0.8rem 1.2rem;\n    border-bottom: solid 0.1rem var(--color-bg-stripe);\n}\n\n.originSelect {\n    margin-right: 0.4rem;\n}\n\n.statusIcon {\n    display: flex;\n    margin-right: 0.8rem;\n}\n\n.filesCardWrapper {\n    margin-top: 0.8rem;\n    margin-right: 1.2rem;\n    margin-left: 1.2rem;\n}\n\n.placeholderWrapper {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    align-items: center;\n    justify-content: center;\n\n    margin-right: 1.2rem;\n    margin-left: 1.2rem;\n}\n\n.placeholderText {\n    margin-bottom: 0;\n}\n\n.buttonsWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 0.8rem 1.2rem;\n}\n\n.toProject {\n    margin-left: 0.8rem;\n}\n\n.timer {\n    display: flex;\n    margin-right: 0.8rem;\n}\n\n.blockWrapper {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 0.8rem;\n}\n\n.stepIndicatorWrapper {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0.8rem;\n}\n\n.stepIndicatorCheck {\n    margin-right: 1.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FileImport__container___cuAl4`,
	"wrapper": `FileImport__wrapper___NPQ6r`,
	"filesCard": `FileImport__filesCard___QDAyd`,
	"activeFileCard": `FileImport__activeFileCard___SJXIS`,
	"btnChooseAll": `FileImport__btnChooseAll___KvvVQ`,
	"tagWrapper": `FileImport__tagWrapper___DJICB`,
	"body": `FileImport__body___mcyZz`,
	"filesUploadBtn": `FileImport__filesUploadBtn___Mgc_x`,
	"controlsForFilesCard": `FileImport__controlsForFilesCard___ZfXxA`,
	"originSelect": `FileImport__originSelect___santg`,
	"statusIcon": `FileImport__statusIcon___o1ffb`,
	"filesCardWrapper": `FileImport__filesCardWrapper___kLgm1`,
	"placeholderWrapper": `FileImport__placeholderWrapper___Kk6aN`,
	"placeholderText": `FileImport__placeholderText___TpSs6`,
	"buttonsWrapper": `FileImport__buttonsWrapper___UvMjX`,
	"toProject": `FileImport__toProject___cn1i6`,
	"timer": `FileImport__timer___cUZDl`,
	"blockWrapper": `FileImport__blockWrapper___onlM4`,
	"stepIndicatorWrapper": `FileImport__stepIndicatorWrapper___He9pL`,
	"stepIndicatorCheck": `FileImport__stepIndicatorCheck___wc8MK`
};
export default ___CSS_LOADER_EXPORT___;
